<template>
  <table :class="table.style">
    <Row
      v-for="row in table.rows"
      :key="row.id"
      :row="row"
      :entryItems="entryItems"
      @updated="updated($event)"
    />
  </table>
</template>

<script>
// import Column from "@/components/document/generator/block/table/Column";
import Row from "@/components/document/generator/block/table/Row";
// import TableHeader from "@/components/document/generator/block/table/TableHeader";
export default {
  name: "Table",
  props: ["table", "entryItems"],
  components: {
    Row
  },
  methods: {
    // updatedRow(event, index) {
    //   // let copy = Object.assign({}, this.listElement);
    //   let copy = JSON.parse(JSON.stringify(this.table));
    //   copy.rows[index] = event;
    //   this.$emit("updated", copy);
    // }
    updated(event) {
      this.$emit("updated", event);
    }
  }
};
</script>
